/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}
/**
 * 是否是空对象
 * @param {*} s
 */
export function isEmptyObject (s) {
  return Object.keys(s).length === 0 ? true : false
}
/**
 * 是否为null
 * @param {*} s
 */
export function  isNull (s) {
  return Object.prototype.toString.call(s).slice(8, -1) === 'Null'
}
/**
 * 是否为undefined
 * @param {*} s
 */
export function  isUndefined (s) {
  return Object.prototype.toString.call(s).slice(8, -1) === 'Undefined'
}
/**
 * 是否为undefined、null
 * @param {*} s
 */
export function  isUndefinedAndNull (s) {
  return Object.prototype.toString.call(s).slice(8, -1) === 'Undefined'||Object.prototype.toString.call(s).slice(8, -1) === 'Null'
}
export function isJSON(str) {
  console.log(str)
  if (typeof str == 'string') {
      try {
          var obj=JSON.parse(str);
          if(typeof obj == 'object' && obj ){
              return true;
          }else{
              return false;
          }

      } catch(e) {
          console.log('error：'+str+'!!!'+e);
          return false;
      }
  }
}